import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useEffect } from 'react';
import { AppHeader } from '@/widgets/app-layout';

/**
 * 지원되지 않는 해상도 안내
 * 320px 미만의 극소 화면에서 표시
 */
function UnsupportedScreenOverlay() {
  return (
    <div className="fixed inset-0 z-9999 bg-background hidden max-[319px]:flex items-center justify-center p-6">
      <div className="text-center">
        <p className="text-lg font-semibold text-foreground mb-2">지원되지 않는 해상도</p>
        <p className="text-sm text-muted-foreground">
          이 서비스는 320px 이상의
          <br />
          화면 너비를 지원합니다.
        </p>
      </div>
    </div>
  );
}

/**
 * 페이지 이동 시 스크롤 위치를 상단으로 초기화
 */
function ScrollToTop() {
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: 경로 변경 시 스크롤 초기화를 위해 pathname 의존성 필요
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return null;
}

function RootComponent() {
  return (
    <>
      <ScrollToTop />
      <UnsupportedScreenOverlay />
      <div className="max-[319px]:hidden">
        <AppHeader />
        <Outlet />
      </div>
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
